import { render, staticRenderFns } from "./Anchor.vue?vue&type=template&id=431b5f22&scoped=true"
import script from "./Anchor.vue?vue&type=script&lang=js"
export * from "./Anchor.vue?vue&type=script&lang=js"
import style0 from "./Anchor.vue?vue&type=style&index=0&id=431b5f22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "431b5f22",
  null
  
)

export default component.exports